import React, { useState } from "react";
import "./overview.scss";
import TransactionData from "./overviewComponents/TransactionData";
import ComplaintsTable from "./overviewComponents/ComplaintsTable";
import BillingCycleGraph from "./overviewComponents/BillingCycleGraph";
import SimplData from "./overviewComponents/SimplData";
import AllInOneGraph from "./overviewComponents/AllInOneGraph";
import { PaymentModeChart } from "./overviewComponents/PieChart";
import { TransactionStatusChart } from "./overviewComponents/PieChart";
import { ChannelsStatusChart } from "./overviewComponents/PieChart";

function Overview() {
  const [selectionFilter, setSelectionFilter] = useState("Amount");

  return (
    <div className="main">
      <div className="part1">
        <TransactionData />
      </div>
      <div className="part2">
        <div className="internalPart2">
          <div className="piechart">
            <PaymentModeChart 
              selectionFilter={selectionFilter} 
              setSelectionFilter={setSelectionFilter} 
            />
            <div className="piechart-right">
              <TransactionStatusChart />
              <ChannelsStatusChart 
                selectionFilter={selectionFilter} 
                setSelectionFilter={setSelectionFilter} 
              /> 
            </div>
          </div>
        </div>
      </div>
      <div className="part3">
        <AllInOneGraph />
      </div>
    </div>
  );
}

export default Overview;
